export const productsArray = [
  {
    category: 'sp',
    title: 'Сири плавлені ковбасні копчені',
    img: new URL('../../images/products/sp_1x.png', import.meta.url),
    img2: new URL('../../images/products/sp_2x.png', import.meta.url),
    text: 'виготовлені тільки з натуральних складових та з натуральним копченням, з різними варіантами наповнювачів - шинка, паприка, зелень тощо',
  },
  {
    category: 'psp',
    title: 'Продукти сирні плавлені ковбасні',
    img: new URL('../../images/products/psp_1x.png', import.meta.url),
    img2: new URL('../../images/products/psp_2x.png', import.meta.url),
    text: 'більш дешева сирна продукція в широкому асортименті з натуральним копченням та без нього, з різними наповнювачами - шинка, паприка, зелень, та ароматизаторами',
  },
  {
    category: 'sppp',
    title: 'Сири та продукти сирні плавлені пастоподібні',
    img: new URL('../../images/products/spp_1x.png', import.meta.url),
    img2: new URL('../../images/products/spp_2x.png', import.meta.url),
    text: 'пастоподібна продукція в тарі різноманітного обьєму',
  },
];
